import axios from 'axios';
import {
  AttributesApi,
  CriteriaApi,
  TrialManagementApi,
  ChatEntriesApi,
  DiseasesApi,
  ContactApi,
  LocationApi,
  UserTrialsApi,
  DependencyApi,
  QuestionsApi,
  HospitalsApi,
  AuthApi,
  ConfigurationApi,
  InviteApi,
  NotificationsApi,
  PermissionsApi,
  PreferencesApi,
  ProfileApi,
  TeamApi,
  TokenApi,
  UserApi,
  CategoryApi,
  DelayIndexApi,
  SurveyManagementApi,
  SurveyQuestionsApi,
  SurveyDependencyApi,
  UserSurveysApi,
} from '@data/sdk/match';
import { axiosInterceptors } from './axios-interceptors';

const matchingApi = axiosInterceptors(
  axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
  }),
);

export const MatchingApi = {
  attributes: new AttributesApi({ isJsonMime: () => true }, undefined, matchingApi),
  category: new CategoryApi({ isJsonMime: () => true }, undefined, matchingApi),
  chat: new ChatEntriesApi({ isJsonMime: () => true }, undefined, matchingApi),
  contact: new ContactApi({ isJsonMime: () => true }, undefined, matchingApi),
  criteria: new CriteriaApi({ isJsonMime: () => true }, undefined, matchingApi),
  dependency: new DependencyApi({ isJsonMime: () => true }, undefined, matchingApi),
  diseases: new DiseasesApi({ isJsonMime: () => true }, undefined, matchingApi),
  hospitals: new HospitalsApi({ isJsonMime: () => true }, undefined, matchingApi),
  location: new LocationApi({ isJsonMime: () => true }, undefined, matchingApi),
  questions: new QuestionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  trialManagement: new TrialManagementApi({ isJsonMime: () => true }, undefined, matchingApi),
  userTrials: new UserTrialsApi({ isJsonMime: () => true }, undefined, matchingApi),
  userSurveys: new UserSurveysApi({ isJsonMime: () => true }, undefined, matchingApi),
  auth: new AuthApi({ isJsonMime: () => true }, undefined, matchingApi),
  configurations: new ConfigurationApi({ isJsonMime: () => true }, undefined, matchingApi),
  invites: new InviteApi({ isJsonMime: () => true }, undefined, matchingApi),
  notifications: new NotificationsApi({ isJsonMime: () => true }, undefined, matchingApi),
  permissions: new PermissionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  preferences: new PreferencesApi({ isJsonMime: () => true }, undefined, matchingApi),
  profile: new ProfileApi({ isJsonMime: () => true }, undefined, matchingApi),
  token: new TokenApi({ isJsonMime: () => true }, undefined, matchingApi),
  user: new UserApi({ isJsonMime: () => true }, undefined, matchingApi),
  team: new TeamApi({ isJsonMime: () => true }, undefined, matchingApi),
  delayIndex: new DelayIndexApi({ isJsonMime: () => true }, undefined, matchingApi),
  surveyManagement: new SurveyManagementApi({ isJsonMime: () => true }, undefined, matchingApi),
  surveyQuestions: new SurveyQuestionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  surveyQuestionDependencies: new SurveyDependencyApi(
    { isJsonMime: () => true },
    undefined,
    matchingApi,
  ),
};
